/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AdjustmentsInputs */

const en_adjustments = /** @type {(inputs: AdjustmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjustments`)
};

const es_adjustments = /** @type {(inputs: AdjustmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

/**
* | output |
* | --- |
* | "Adjustments" |
*
* @param {AdjustmentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const adjustments = /** @type {((inputs?: AdjustmentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AdjustmentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adjustments(inputs)
	return es_adjustments(inputs)
});